<template lang="pug">
  .easyparcel
    v-container(style="max-width:600px")
      v-layout
        v-row.fill-height.ma-0(align="center" justify="center")
          div.mx-auto
            v-img.mx-auto(:src="require('@/assets/images/woo-logo.png')" style="width:140px" contain)

      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align="center" justify="center")
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

      v-card.mt-3(v-else flat)
        v-card-title
          v-layout
            div.h6.basic800--text {{ $t('integration_settings') }}
        v-divider
        v-window.pa-4
          v-window-item(:value="1")
            v-form
              v-layout.mb-3
                p.s1.primary500--text.mb-0 {{ $t('inventory_sync') }}
                v-spacer
                div
                  y-switch.ma-0.pa-0(v-model="sync_inventory")
              v-layout.mb-3
                p.s1.primary500--text.mb-0 {{ $t('product_sync') }}
                v-spacer
                div
                  y-switch.ma-0.pa-0(v-model="sync_product" @change="productSyncChange")
              v-layout
                p.s1.primary500--text.mb-0 {{ $t('manage_order') }}
                v-spacer
                div
                  y-switch.ma-0.pa-0(v-model="manage_order" @change="manageOrderChange")
              div(v-if="sync_product")
                //v-divider.my-4
                p.s1.mt-10.primary500--text {{ $t('sync_woocommerce_with_yezza') }}
                v-layout.my-2
                  p.mb-0.s2.basic600--text {{ $t('new_product_is_created') }}
                  v-spacer
                  div
                    y-checkbox.ma-0.pa-0(v-model="sync_new" color="success" hide-details)
                v-layout.my-2
                  p.mb-0.s2.basic600--text {{ $t('product_is_updated') }}
                  v-spacer
                  div
                    y-checkbox.ma-0.pa-0(v-model="sync_updated" color="success" hide-details)
                v-layout.my-2
                  p.mb-0.s2.basic600--text {{ $t('product_is_deleted') }}
                  v-spacer
                  div
                    y-checkbox.ma-0.pa-0(v-model="sync_deleted" color="success" hide-details)


        v-card-actions
          v-spacer
          v-btn.button-AA-medium.mr-2.white--text(color="info500" height=32 depressed @click="save" :loading="isLoading")
            | {{ $t('save') }}

</template>

<script>
import { mapActions } from "vuex"

export default {
  name: "SettingsWooCommerce",
  props: ["company", "ecommerce"],
  data: () => ({
    isFetching: false,
    sync_product: false,
    sync_inventory: false,
    sync_new: false,
    sync_updated: false,
    sync_deleted: false,
    isLoading: false,
    manage_order: false
  }),
  computed: {
    sync_product_inventory () {
      return this.sync_inventory ? "both" : "inactive"
    },
    sync_product_added () {
      return this.sync_new ? "in" : "inactive"
    },
    sync_product_updated () {
      return this.sync_updated ? "in" : "inactive"
    },
    sync_product_deleted () {
      return this.sync_deleted ? "in" : "inactive"
    }
  },
  watch: {
    ecommerce: {
      deep: true,
      immediate: true,
      handler (val) {
        if(val.id) {
          if (val.sync_product_inventory === "both") {
            this.sync_inventory = true
          } else if (val.sync_product_inventory === "inactive") {
            this.sync_inventory = false
          }
          if (val.sync_product_added === "in") {
            this.sync_new = true
            this.sync_product = true
          } else if (val.sync_product_added === "inactive") {
            this.sync_new = false
          }
          if (val.sync_product_updated === "in") {
            this.sync_updated = true
            this.sync_product = true
          } else if (val.sync_product_updated === "inactive") {
            this.sync_updated = false
          }
          if (val.sync_product_deleted === "in") {
            this.sync_deleted = true
            this.sync_product = true
          } else if (val.sync_product_deleted === "inactive") {
            this.sync_deleted = false
          }
          this.isFetching = false
        } else {
          this.isFetching = false
        }
      }
    },
  },
  mounted () {
   this.$axios.get(`/forms?company=${this.company.id}&type=woocommerce&include_hidden=true`)
    .then(resp => {
      if (resp.data.results.length > 0) {
        this.manage_order = true
      }
    })
    .catch(() => {})
  },
  methods: {
    ...mapActions([
      "showMessage"
    ]),
    save () {
      if (this.ecommerce.id) {
        let data = {
          sync_product_inventory: this.sync_product_inventory,
          sync_product_added: this.sync_product_added,
          sync_product_updated: this.sync_product_updated,
          sync_product_deleted: this.sync_product_deleted,
        }
        this.axios.patch(`/ecommerce/woocommerce/${this.ecommerce.id}/`, data)
        .then(resp => {
          if (resp.data.id) {
            this.$emit('update:ecommerce', resp.data)
            this.$emit("finish")
          }
        })
        .catch(() => {
          this.showMessage(["error", "Unable to complete your request. Please try again later"])
        })
      } else {
        this.showMessage(["error", "Unable to complete your request. Please try again later"])
      }
    },
    productSyncChange () {
      if (this.sync_product === false) {
        this.sync_new = false
        this.sync_updated = false
        this.sync_deleted = false
      }
    },
    manageOrderChange () {
      if (this.manage_order === true) {
        this.$axios.get(`/forms?company=${this.company.id}&type=woocommerce&include_hidden=true`)
          .then(resp => {
            if (resp.data.results.length === 0) {
              let params = {
                company : this.company.id,
                name : 'WooCommerce',
                email_enabled : false,
                email_required : false,
                layout : 'inquiry',
                extra_fields : [],
                type: 'woocommerce',
                members: [this.company.primary_owner],
                hidden: true
              }
              this.$axios.post(`/forms/`, params)
                .catch(() => {
                  this.showMessage(['error', this.$t('error_message.error_occured')])
                })
            }
          }).catch(() => {})
      } else {
        this.$axios.get(`/forms?company=${this.company.id}&type=woocommerce&include_hidden=true`)
          .then(resp => {
            if (resp.data.results.length > 0) {
              this.$axios.patch(`/forms/${resp.data.results[0].id}/`, { status: 'deleted' })
                .then(() => {
                  this.showMessage(['success', this.$t('success_message.manage_order_disabled')])
                })
                .catch(() => {
                  this.showMessage(['error', this.$t('error_message.error_occured')])
                })
            }
          })
      }
    }
  }
}
</script>

<i18n>
{
  "en": {
    "integration_settings": "Integration Settings",
    "inventory_sync": "Inventory sync",
    "product_sync": "Product sync",
    "manage_order": "Manage Order",
    "sync_woocommerce_with_yezza": "Sync WooCommerce with Yezza when",
    "new_product_is_created": "New product is created",
    "product_is_updated": "Product is updated",
    "product_is_deleted": "Product is deleted"
  },
  "id": {
    "integration_settings": "Setelan Integrasi",
    "inventory_sync": "Sinkronisasi inventaris",
    "product_sync": "Sinkronisasi produk",
    "manage_order": "Kelola Pesanan",
    "sync_woocommerce_with_yezza": "Sinkronkan WooCommerce dengan Yezza saat",
    "new_product_is_created": "Produk baru telah dibuat",
    "product_is_updated": "Produk diperbarui",
    "product_is_deleted": "Produk dihapus"
  }
}
</i18n>
